import { render } from "./i-copy.vue?vue&type=template&id=0293915c"
import script from "./i-copy.vue?vue&type=script&lang=js"
export * from "./i-copy.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__